<template>
    <div class="person-info" v-if="userInfos">
        <div class="person-info-top flex items-center">
            <div class="lv-guang">
                <div class="bg-img" :style="`background-image: url(${imgSrc});`">

                </div>
            </div>
            <div class="person-info-mail">
                <p>{{userInfos.first_name}}</p>
                <p>{{userInfos.email}}</p>
            </div>
        </div>
        <div class="person-info-bottom flex">
            <div class="flex flex-col">
                <span>The salesman</span>
                <span>Salesman’s mail</span>
                <span>Salesman’s whatsapp</span>
            </div>
            <div class="flex flex-col">
                <span>{{salemanInfos.name}}</span>
                <span>{{salemanInfos.email}}</span>
                <span>{{salemanInfos.phone}}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            imgSrc: require('@/assets/images/women.png'),
            salemanInfos: {},
            userInfos: {},
        };
    },
    methods: {
        fetchData() {
            const id = localStorage.getItem('aobiyaUserInfos') ?
                JSON.parse(localStorage.getItem('aobiyaUserInfos')).salesman_id : 2;
            API.get(`/api/aobiya/seller/${id}`).then(res => {
                this.salemanInfos = res;
                this.$loading.close();
            }).catch(() => {
                this.$loading.close();
            });
        },
        fetchUserInfo() {
            const guestId = JSON.parse(localStorage.getItem('aobiyaUserInfos')).id;
            API.get(`/api/aobiya/guest/${guestId}`).then(res => {
                this.userInfos = res;
                if (res.portrait_md5) {
                    this.imgSrc = res.portrait_md5;
                }
            });
        },
    },
    created() {
        this.$loading.show();
        this.fetchData();
        this.fetchUserInfo();
    },
};
</script>

<style lang="scss" scoped>
    .person-info {
        padding: 76px;
        background-color: #fff;
        .person-info-top {
            padding-bottom: 40px;
            border-bottom: 1px solid #eee;
        }
        .lv-guang {
            width: 96px;
            height: 96px;
            position: relative;
            border-radius: 50%;
            border: 1px solid #70CEB6;
            box-shadow: 0 0 20px rgba(113, 206, 182, .6);
            margin-right: 61px;
        }
        .bg-img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 88px;
            height: 88px;
            border-radius: 50%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
        }
        .person-info-mail {
            p {
                font-size: 20px;
                color: #54525F;
                letter-spacing: 0;
            }
            p:nth-child(1) {
                font-family: PingFangSC-Medium;
                margin-bottom: 10px;
            }
            p:nth-child(2) {
                font-family: PingFangSC-Regular;
            }
        }
    }
    .person-info-bottom {
        > div {
            span {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                letter-spacing: 0;
            }
            span:first-child {
                padding: 28px 0;
            }
            span:nth-child(2) {
                padding-bottom: 28px;
            }
        }
        > div:first-child {
            margin-right: 32px;
            padding-left: 5px;
            span{
                color: #666666;
            }
        }
        > div:nth-child(2) {
            span {
                color: #54525F;
            }
        }
    }
</style>
